module.exports = __webpack_public_path__ + "static/media/Payment Gateway Solutions.e550a0a5.jpg";